import { AxiosResponse } from 'axios';
import { SET_CLIENTS, SET_CLIENT, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_CLIENT_ISLOADING,
  DELETE_CLIENT,
  EDIT_CLIENT,
  GET_CLIENTS,
  GET_CLIENT,
  REGISTER_CLIENT,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Client from '@/services/client';
import { Module } from 'vuex';
import { EditClient, RegisterClient, GetClient } from '@/dtos/client.dto';

const client: Module<any, {}> = {
  state: {
    client: {
      data: null,
      isLoading: false,
    },
    clients: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    client: (state: { client: any }) => state.client,
    clients: (state: { clients: any }) => state.clients,
  },
  mutations: {
    [SET_CLIENT]: (
      state: { client: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.client.data = payload.data) : null,
        (state.client.isLoading = payload.isLoading);
    },
    [SET_CLIENTS]: (
      state: { clients: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.clients.data = payload.data) : null,
        (state.clients.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_CLIENT]: async ({ commit }: any, payload: any) => {
      commit(SET_CLIENT, { data: null, isLoading: true });

      const result: AxiosResponse = await Client.registerClient(
        payload as RegisterClient
      );

      if (result) {
        if (result.data.status) {
          commit(SET_CLIENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_CLIENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CLIENT, { isLoading: false });
        return false;
      }
    },
    [GET_CLIENTS]: async ({ commit }: any, payload: any) => {
      commit(SET_CLIENTS, { data: null, isLoading: true });

      const result: AxiosResponse = await Client.getClients(
        payload as GetClient
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_CLIENTS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_CLIENTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CLIENTS, { isLoading: false });
        return false;
      }
    },
    [GET_CLIENT]: async ({ commit }: any, payload: any) => {
      commit(SET_CLIENT, { data: null, isLoading: true });

      const result: AxiosResponse = await Client.getClients(
        payload as GetClient
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_CLIENT, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_CLIENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CLIENT, { isLoading: false });
        return false;
      }
    },
    [EDIT_CLIENT]: async ({ commit }: any, payload: any) => {
      commit(SET_CLIENT, { data: null, isLoading: true });

      const result: AxiosResponse = await Client.editClient(
        payload as EditClient
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_CLIENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_CLIENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CLIENT, { isLoading: false });
        return false;
      }
    },
    [DELETE_CLIENT]: async ({ commit }: any, payload: string) => {
      commit(SET_CLIENT, { data: null, isLoading: true });

      const result: AxiosResponse = await Client.deleteClient(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_CLIENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_CLIENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_CLIENT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_CLIENT_ISLOADING]: ({ commit }) => {
      commit(SET_CLIENT, { isLoading: false });
      commit(SET_CLIENTS, { isLoading: false });
    },
  },
};

export default client;

